import { render, staticRenderFns } from "./MasterDeposit.vue?vue&type=template&id=2c9f7cdb&scoped=true&"
import script from "./MasterDeposit.vue?vue&type=script&lang=js&"
export * from "./MasterDeposit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9f7cdb",
  null
  
)

export default component.exports